module.exports = __webpack_public_path__ + "img/style-presets.3d2146ff.svg";